import React from 'react';
import { ArrowUpRight, FilePenLine, MessageSquare } from 'lucide-react';

export const EMPTY_CHAT_PROMPTS = ['Realizar una consulta', 'Hacer una diligencia'] as const;

interface EmptyChatActionsProps {
  onSend: (text: string) => void;
  disabled?: boolean;
}

const EmptyChatActions: React.FC<EmptyChatActionsProps> = ({ onSend, disabled = false }) => (
  <section className="mx-auto flex w-full max-w-2xl flex-1 flex-col items-center justify-center px-4 py-10 text-center">
    <img src="/juris-logo.png" alt="" width={112} height={112} className="mb-6 h-28 w-28 object-contain drop-shadow-lg" />
    <h1 className="text-3xl font-bold tracking-tight text-ink sm:text-4xl">¿En qué te ayudo?</h1>
    <p className="mt-3 max-w-md text-sm leading-relaxed text-muted sm:text-base">Consulta, prepara una diligencia o escribe directamente lo que necesitas.</p>
    <div className="mt-8 grid w-full max-w-lg gap-3 sm:grid-cols-2">
      {EMPTY_CHAT_PROMPTS.map((text, index) => {
        const Icon = index === 0 ? MessageSquare : FilePenLine;
        return (
          <button key={text} type="button" disabled={disabled} onClick={() => onSend(text)}
            className="group flex min-h-16 items-center gap-3 rounded-2xl border border-line bg-panel px-4 py-4 text-left text-sm font-semibold text-ink transition hover:border-juris/50 hover:bg-raised disabled:cursor-wait disabled:opacity-50">
            <Icon size={20} className="shrink-0 text-juris" aria-hidden="true" />
            <span className="flex-1">{text}</span>
            <ArrowUpRight size={16} className="shrink-0 text-muted transition group-hover:text-juris" aria-hidden="true" />
          </button>
        );
      })}
    </div>
  </section>
);

export default EmptyChatActions;
